
const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}

const validateMainSkcDetail = async (rule, value, callback, context) => {
    let tips = ''
    value.forEach(i => {
        if(i.img1 && i.img1.length == 0){
            tips = '请添加细节图/主图'
        }else if(i.img2 && i.img2.length == 0){
            tips = '请添加方形图'
        }else if(i.img3 && i.img3.length == 0){
            tips = '请添加色块图'
        }
    })
    if (tips) {
        callback(new Error(tips));
    } else if (context.$refs.skcDetail) {
        let errMsg = await context.$refs.skcDetail.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
}
const validateSiteDetailImage = async (rule, value, callback, context) =>{
    let errMsg = await context.$refs.skcSiteDetailImage.method_validImage()
    if(errMsg){
        callback(new Error(errMsg));
    }else{
        callback()
    }
}

const validateSizeChart = (rule, value, callback, context) => {
    let errMsg = context.$refs.sizeChartRef.validSizeChart();
    if(errMsg){
        callback(new Error(errMsg));
    }else{
        callback()
    }
}

const validateSpecifications = (rule, value, callback, context) => {
    let errMsg = context.$refs.specificationRef.validSpecifications();
    if(errMsg){
        callback(new Error(errMsg));
    }else{
        callback()
    }
}
// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        title: [
            {required: true, message: '请输入商品标题'},
        ],
        skcDetail: [
            {required: true, message: '请添加图片'},
            {validator: contextWrap(validateMainSkcDetail, context)}
        ],
        skcSiteDetailImage:[
            {required: false},
            {validator: contextWrap(validateSiteDetailImage, context)}
        ],
        skuAttrs:[
            {validator: contextWrap(validateSpecifications, context)}
        ],
        // specifications:[{required: true, message: '请填写规格'}],
        sizeChart:[
            {validator: contextWrap(validateSizeChart, context)}
        ],
    };
}


export {
    RULES as default,
}
